import { action, makeAutoObservable } from "mobx";
import { RootStore } from "../index";
import NewsModel from "../../model/NewsModel";

export class PageMassageStore { 
  error = "";

  public isOpenModal = false;
  public dataModal = {
    href: "",
    textHref: "",
    description: "",
  };

  countShowTop = 0;

  showNotView = false;

  pagination = {
    countPage: 1,
    countRow: 1,
    currentPage: 1,
  };

  orderModel: string = "";
  orderField: string = "id";
  orderBy: string = "DESC";

  arItems = [];

  private rootStore: RootStore | undefined;

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @action init() {
    this.reload(true);
  }

  @action setModal(data: any) {
    if (Array.isArray(data)) {
      for (let i in data) {
        let dt= data[i];
        if(dt['props'].hasOwnProperty('OrderId')){
            this.isOpenModal = true;
            this.dataModal.description=dt.name;
            this.dataModal.href='/order/'+dt.props.OrderId+'/';
            this.dataModal.textHref='Заказ № '+dt.props.OrderId;
            this.setRead({id:dt.id,isRead:false},true);
            break;
        }
      }
    } 
    
  }

  @action onCloseModal = () => {
    this.setCountShowTop();
  };

  @action reload = (init: boolean = false) => {
    if (init) {
      this.pagination.currentPage = 1;
    }
    let userId = this.rootStore?.mainStore.user.id;
    NewsModel.getRows(
      this.rootStore?.mainStore.getClientId(),
      (result: any) => {
        result.data.rows.map((item: any) => {
          item["isOpen"] = false;
          item["isRead"] = item.props.UserViews.includes(userId);
          return item;
        });
        this.arItems = result.data.rows;
        this.pagination = result.data.pagination;
      },
      this.setError
    );
  };

  setFilter(showNotView = false) {
    let filter = {};
    // @ts-ignore
    filter["props"] = {
      ["Clients-contains"]: this.rootStore?.mainStore.getClientId(),
    };

    if (this.showNotView || showNotView) {
      // @ts-ignore
      filter["props"]["UserViews-containsNot"] =
        this.rootStore?.mainStore.user.id;
    }

    return filter;
  }

  @action
  setError = (error: any) => {
    if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined
    ) {
      this.error = String(error.response.data.message);
    }
  };

  private static setSort() {
    return {
      orderModel: "",
      orderField: "id",
      orderBy: "DESC",
    };
  }

  @action setOpen = (item: any) => {
    item.isOpen = !item.isOpen;
    if (!item.isRead) {
      this.setRead(item);
    }
  };

  @action setRead(item: any,showModal=false) {
    item.isRead = true;
    NewsModel.setView(
      item.id,
      (res: any) => {
        this.setCountShowTop(showModal);
      },
      this.setError
    );
  }

  @action allRead = () => {
    this.arItems.map((item: any) => {
      if (!item.isRead) {
        NewsModel.setView(
          item.id,
          (res: any) => {
            this.setCountShowTop();
          },
          this.setError
        );
      }
      item["isRead"] = true;
      return item;
    });
  };

  @action filterNoRead = () => {
    this.showNotView = !this.showNotView;
    this.init();
  };

  @action
  setCountShowTop = (showModal=false) => {
    NewsModel.getCount(
      this.rootStore?.mainStore.getClientId(),
      (result: any) => {
        this.countShowTop = result.data.count;
        if(!showModal){
            this.setModal(result.data?.popup?.rows);
        }
      },
      this.setError
    );
  };

  onCurrentPage = (page: number) => {
    this.pagination.currentPage = page;
    this.reload();
  };
}
